import React, { useState, useEffect } from 'react';
import { getPurchaseOrder, viewPurchaseOrder } from '../../api/resources/PurchaseOrders';
import PurchaseOrderComponent from './PurchaseOrder';
import { parsePoWithDates } from './poUtils.js'

const blankPurchaseOrder = {
  supplier: "",
  location: "",
  lineItems: [],
  subtotal: 0,
  vatPercent: 0.0,
  spendDate: new Date().toISOString().split('T')[0],
  status: 'unsaved',
  isEditing: true
};

export default function PurchaseOrderProvider(props) {

  const [PurchaseOrder, setPurchaseOrder] = useState(null);

  useEffect(() => {
    const loadPO = async () => {
      const { purchaseOrderId: id } = props.match.params;
      let purchaseOrder = (id === 'new' ) ? blankPurchaseOrder : await getPurchaseOrder(id);
      if (id != 'new') purchaseOrder = parsePoWithDates(purchaseOrder);
      if (id != 'new') viewPurchaseOrder(id);
      setPurchaseOrder(purchaseOrder);
    }

    loadPO().catch(console.error);

  }, []);

  return PurchaseOrder ? <PurchaseOrderComponent purchaseOrder={PurchaseOrder} {...props} /> : null;
}